var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"border":"none"},attrs:{"src":_vm.externalLink,"referrerpolicy":"origin","width":"100%","height":"1000px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }